import React, { useEffect, useState } from 'react';
import { Client } from 'constants/interface';
import { useDispatch, useSelector } from 'hooks/store';
import {
  cleanClientsAction,
  clientsEntitiesSelector,
  clientsIdsSelector,
  getClientsListAction,
  isLoadingClientsSelector,
} from 'state/slices/clients';
import { Select, Spinner } from 'UI';
import { FormItemProps } from 'antd';

import {
  RemoteSelectContent,
  RemoteSelectSpinnerContainer,
} from './style';

interface ClientSelectSearchProps {
  onSelect: (client?: Client) => void
  form?: {
    FormItem: React.ComponentType<FormItemProps>
    formItemProps: FormItemProps
  }
  disabled?: boolean
  initialClient?: Client
}

const ClientSelectSearch = ({
  onSelect,
  form,
  disabled,
  initialClient,
}: ClientSelectSearchProps): JSX.Element => {
  const dispatch = useDispatch();

  const clientsEntities = useSelector(clientsEntitiesSelector);
  const clientsIds = useSelector(clientsIdsSelector);
  const isLoadingClients = useSelector(isLoadingClientsSelector);
  const clients = clientsIds
    .map((clientId) => clientsEntities[clientId])
    .filter((client) => !!client) as Client[];

  const [internalLoading, setInternalLoading] = useState(false);

  const [selectedClient, setSelectedClient] = useState<Client | undefined>(initialClient);
  const [isDropdownOpened, setDropdownOpened] = useState<boolean>(false);

  const initialClientId = initialClient?.id;

  useEffect(() => {
    if (initialClientId) {
      dispatch(cleanClientsAction());
      setSelectedClient(initialClient);
    }
  }, [initialClientId]);

  const [
    clientSearchTimeout,
    setClientSearchTimeout,
  ] = useState<number>();
  const onClientSearch = (search: string) => {
    if (!search) {
      dispatch(cleanClientsAction());
    } else {
      setInternalLoading(true);
      window.clearTimeout(clientSearchTimeout);
      const searchTimeout = window.setTimeout(() => {
        dispatch(getClientsListAction({
          search,
          isPaginated: false,
        }));
        setInternalLoading(false);
      }, 500);
      setClientSearchTimeout(searchTimeout);
    }
  };

  const selectedClientOption = selectedClient
    ? [selectedClient]
    : [];

  const selectItems = isDropdownOpened
    ? clients
    : selectedClientOption;

  const selectElement = (
    <Select
      placeholder="Selecione um cliente"
      className="SELECT_CLASSNAME"
      showArrow={false}
      showSearch
      onDropdownVisibleChange={(isOpen) => setDropdownOpened(isOpen)}
      onSearch={onClientSearch}
      onSelect={(clientId) => {
        const curSelectedClient = clientsEntities[clientId];
        if (curSelectedClient) {
          setSelectedClient(curSelectedClient);
          onSelect(curSelectedClient);
        }
        // onSelect(clientsEntities[clientId])
      }}
      filterOption={false}
      notFoundContent={<></>}
      disabled={disabled}
      dropdownRender={(menu) => (
        <div>
          <RemoteSelectContent>
            {menu}
            {(internalLoading || isLoadingClients) && (
              <RemoteSelectSpinnerContainer>
                <Spinner />
              </RemoteSelectSpinnerContainer>
            )}
          </RemoteSelectContent>
        </div>
      )}
    >
      {selectItems.map((clientOption) => (
        <Select.Option
          value={clientOption.id}
          key={clientOption.id}
        >
          {clientOption.name}
        </Select.Option>
      ))}
    </Select>
  );

  return (
    form ? (
      <form.FormItem
        {...form.formItemProps}
      >
        { selectElement }
      </form.FormItem>
    ) : selectElement
  );
};

export default ClientSelectSearch;
